// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1QLj0","title":"AfterBackImages_title__3JtAM","images":"AfterBackImages_images__13ppa"};